import Vue from 'vue'
import { DateFormat, DateFormat2 } from '@/utils/date/DateUtil'
import * as tyepconvert from '@/utils/tyepconvert'
// 将tyepconvert 都加入过滤器
for (const [key, val] of Object.entries(tyepconvert)) {
  Vue.filter(key,val)
}

Vue.filter('DateFormat', DateFormat)
Vue.filter('DateFormat2', DateFormat2)


